import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
  name: "extended-limit-requests",
  component: () =>
    import(
      /* webpackChunkName: "auth-layout" */ "@/layouts/PrincipalLayout.vue"
    ),
  children: [
    {
      path: "",
      name: "extended-limit-requests-index",
      beforeEnter: [isVerifyTokenGuard],
      meta: {
        breadcrumbs: [
          {
            transKey: "breadcrumbs.extended-limit-requests-index",
            isActive: true,
          },
        ],
      },
      component: () =>
        import(
          /* webpackChunkName: "extended-limit-requests-index" */ "@/modules/admin/extended-limit-requests/views/Index.vue"
        ),
    },
    {
      path: "detail/:id",
      name: "extended-limit-requests-detail",
      beforeEnter: [isVerifyTokenGuard],
      meta: {
        breadcrumbs: [
          {
            route: { name: "extended-limit-requests-index", params: {} },
            transKey: "breadcrumbs.extended-limit-requests-index",
            isActive: false,
          },
          {
            transKey: "breadcrumbs.extended-limit-requests-detail",
            isActive: true,
          },
        ],
      },
      component: () =>
        import(
          /* webpackChunkName: "extended-limit-requests-detail" */ "@/modules/admin/extended-limit-requests/views/Detail.vue"
        ),
    },
  ],
};
